import { render, staticRenderFns } from "./PopupStaffAdd.vue?vue&type=template&id=5d523364&scoped=true"
import script from "./PopupStaffAdd.vue?vue&type=script&lang=js"
export * from "./PopupStaffAdd.vue?vue&type=script&lang=js"
import style0 from "./PopupStaffAdd.vue?vue&type=style&index=0&id=5d523364&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d523364",
  null
  
)

export default component.exports